import { render } from "./propertiesScanCode.vue?vue&type=template&id=3a5d85a2"
import script from "./propertiesScanCode.vue?vue&type=script&lang=js"
export * from "./propertiesScanCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__